<div class="default-dialog">
  <div class="mat-dialog-container">
    <div class="mat-dialog-header default-dialog-header" *ngIf="title">
      <div class="mat-dialog-title">{{title}}</div>
    </div>
    <mat-dialog-content>
      <div class="confirmation-dialog">
        <ng-container> {{ content }} </ng-container>
        <div class="confirmation-dialog-details" *ngIf="data.details?.length">
          <div *ngFor="let item of data.details">
            <strong>{{ item.label }}:</strong> {{ item.value }}
          </div>
        </div>
        <mat-form-field class="full-width-input" *ngIf="typeToConfirm">
          <mat-label>Type {{ typeToConfirm }} to confirm</mat-label>
          <input
            matInput
            (change)="onTypeToConfirmChange($event)"
            (keyup.enter)="onCheckConfirmAction($event)" />
        </mat-form-field>
        <mat-form-field class="full-width-input" *ngIf="data.select">
          <mat-label>{{ data.select.label }}</mat-label>
          <mat-select [formControl]="data.select.control">
            <mat-option
              *ngFor="let option of data.select.options"
              [value]="option.value">
              {{ option.display }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions">
      <button
        mat-flat-button
        *ngFor="let action of actions"
        [ngClass]="getClasses(action)"
        [color]="action.color"
        (click)="onAction(action.key)">
        <i *ngIf="action.icon" class="fa {{action.icon}}"></i>
        <fa-icon *ngIf="action.icon" [icon]="['fas', action.icon]"></fa-icon>
        {{action.label}}
      </button>
    </mat-dialog-actions>
  </div>
</div>
